import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'itfg-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  public renderPasswordResetForm = false;
  public resetPasswordToken: string;
  constructor(private router: Router) {
    if (this.router.url.includes("/password-reset/")) {
      this.resetPasswordToken = this.router.url.split('/').at(-1);
      this.renderPasswordResetForm = true;
    }
  }

  ngOnInit() { }
}
